
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, IconButton, } from '@material-ui/core';
import MBackIcon from '../view/MBackIcon';
import MStatusBar from '../view/MStatusBar';
import MPage from '../view/MPage';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import MDatePicker from '../view/MDatePicker';
import Apis from '../../network/Apis';
import { MatchItemSimple } from './view';
import DateUtils from '../../control/dateutils';
import AppUtils from '../../control/apputlis';


class MatchCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            year: 2020,
            month: 9,
            day: 1,
            MountData: [],
            data: [],
        };

        this.time = 0;
        console.log('MatchCalendar', props);
    }

    componentDidMount() {
        var date = new Date();
        this.state.year = date.getFullYear();
        this.state.month = date.getMonth() + 1;
        this.state.day = date.getDate();

        let time = this.state.year +'-'+this.state.month+'-'+this.state.day
        this.getMountMatchCount();
        this.getSchedule(time)

    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getMountMatchCount = async () => {


        const { year, month, day } = this.state;
        const { typeId } = this.props.match.params;
        let monthstr = month < 10 ? '0' + month : month;

        let result = await Apis.encryptionCountMatchEnd(typeId, year + '-' + monthstr, true);
        console.log('getMountMatchCount', result);
        if (result.code == 200) {
            this.setState({ MountData: result.data });
        }

    }

    getSchedule = async (date) => {
        const { typeId } = this.props.match.params;
        this.time = DateUtils.getMillis(date);
        let result = await Apis.encryptionMatch(typeId, this.time);
        console.log('getSchedule', result);
        if (result.code == 200) {
            this.setState({ data: result.data })
        }
    }

    _onConfirm = () => {
        AppUtils.setStorageObj(AppUtils.MATCH_SELECT_TIMER, this.time);
        window.history.back();
    }

    _onLeftClick = () => {
        let { year, month } = this.state;
        month--;
        if (month < 1) {
            year--;
            month = 12;
        }
        this.setState({ year: year, month: month, data: [] }, () => {
            this.getMountMatchCount();
        });

    }

    _onRightClick = () => {
        let { year, month } = this.state;
        month++;
        if (month > 12) {
            year++;
            month = 1;
        }
        this.setState({ year: year, month: month, data: [] }, () => {
            this.getMountMatchCount();
        });
    }

    _handleDateChange = (data) => {
        this.getSchedule(data.date);
    }


    render() {
        const { classes } = this.props;
        const { value, year, month, MountData, data } = this.state;
        return (
            <MPage backgroundColor='#FFF' Header={
                <Grid container direction='column' alignItems='center'>
                    <Grid container direction='column' alignItems='center' style={{ boxShadow: '1px 1px 3px #F0F0F0', backgroundColor: '#FFF' }}>
                        <MStatusBar />
                        <Grid container direction='row' justify='center' alignItems='center' style={{ height: 48 }} >
                            <MBackIcon />
                            <Typography style={{ fontSize: 17, color: '#0D0D0D' }}>赛程日历</Typography>
                            <ButtonBase onClick={() => this._onConfirm()} className={classes.confirmButton}>确定</ButtonBase>
                        </Grid>
                    </Grid>
                </Grid>
            }>
                <Grid container direction='row' justify='space-between' alignItems='center' style={{ backgroundColor: '#ECF2F6', height: 30, width: '90%', borderRadius: 15, marginTop: 16, marginLeft: '5%' }}>
                    <IconButton
                        className={classes.arrow}
                        style={{ color: '#0D0D0D', marginLeft: 16 }}
                        edge="start"
                        color="default"
                        onClick={() => this._onLeftClick()}
                        aria-label="close">
                        <ArrowBackIosIcon style={{ fontSize: '1.0rem' }} />
                    </IconButton>
                    <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{year + '年' + month + '月'}</Typography>
                    <IconButton
                        className={classes.arrow}
                        style={{ color: '#0D0D0D', marginRight: 16 }}
                        edge="start"
                        color="default"
                        onClick={() => this._onRightClick()}
                        aria-label="close">
                        <ArrowForwardIosIcon style={{ fontSize: '1.0rem' }} />
                    </IconButton>
                </Grid>
                <Grid style={{ marginTop: 8 }}>
                    <MDatePicker
                        year={year}
                        month={month}
                        value={value}
                        MountData={MountData}
                        onChange={(val) => this._handleDateChange(val)}
                    ></MDatePicker>
                </Grid>
                <Grid container direction='column' alignItems='center'>
                    {
                        data && data.map((item, i) => (
                            <MatchItemSimple key={i} data={item} />
                        ))
                    }
                </Grid>
            </MPage>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(1, 1, 1, 1)
    },
    arrow: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    },
    confirmButton: {
        position: 'absolute',
        right: 16,
        fontSize: 13,
        color: 'white',
        padding: theme.spacing(1, 1, 1, 1),
        background: '#007AFF',
        borderRadius: 10,
        width: 50,
        height: 24
    }
}))(MatchCalendar));